import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=a00c7836&scoped=true&"
import script from "./IconSvg.vue?vue&type=script&lang=js&"
export * from "./IconSvg.vue?vue&type=script&lang=js&"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=a00c7836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c7836",
  null
  
)

export default component.exports